import React from 'react';
import { useLocaleState, useTranslate } from 'react-admin';
import { Box, Typography, Paper } from '@mui/material';

/**
 * Kaynak dil bilgilendirme banner'ı — create ve edit formlarında paylaşılır.
 */
export const SourceLanguageBanner = ({ isEdit = false, record }) => {
  const [locale] = useLocaleState();
  const translate = useTranslate();

  const currentLangCode = isEdit ? record?.sourceLanguage || 'tr' : locale;
  const isTr = currentLangCode === 'tr';
  const isEn = currentLangCode === 'en';

  const langName = isTr ? 'Türkçe' : isEn ? 'English' : currentLangCode.toUpperCase();

  return (
    <Paper
      elevation={0}
      sx={{
        px: 1.5,
        py: 1,
        mb: 2,
        width: 'fit-content',
        maxWidth: '100%',
        borderRadius: 2,
        background: 'linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 100%)',
        border: '1px solid #BFDBFE',
      }}
    >
      <Box>
        <Typography
          variant="subtitle2"
          fontWeight={700}
          sx={{ color: '#1E3A8A', fontSize: '0.8rem' }}
        >
          {translate('form.source_language_title', 'Kaynak Dil:')}{' '}
          <span style={{ color: '#2563EB' }}>
            {langName} {isEdit ? ' (Kilitli)' : ''}
          </span>
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: '#1D4ED8', display: 'block', mt: 0.25, lineHeight: 1.35 }}
        >
          {isEdit
            ? translate(
                'form.source_language_locked_desc',
                `Bu kaydın kaynak dili kilitlidir (${langName}). Güncellemeler esas alınarak diğer dillere DeepL ile otomatik çevrilecektir.`,
                { lang: langName },
              )
            : translate(
                'form.source_language_desc',
                'Bu dilde yazın; diğer diller DeepL ile çevrilir. Dil değiştirmek için navbar’ı kullanın.',
              )}
        </Typography>
      </Box>
    </Paper>
  );
};

export default SourceLanguageBanner;
